import { render } from "./ReturnPolicy.vue?vue&type=template&id=2fef6b06"
import script from "../js/return-policy.js?vue&type=script&lang=js&external"
export * from "../js/return-policy.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__